import { Check } from 'lucide-react';

const EmptyState = ({ text }: { text: string }) => (
  <div className="flex min-h-32 flex-col items-center justify-center gap-2 px-6 py-10 text-center">
    <Check className="size-5 text-text-subtle" />
    <p className="m-0 text-sm text-text-muted">{text}</p>
  </div>
);

export default EmptyState;
